<template>
    <div>
        <transition-group name="list" tag="ul">
            <template v-if="checkConditionsToSubGrup(category)">
                <SubGroupCard
                    v-for="(subGroup, key) in category && category['subGroups']" :key="category.groupCode+subGroup.subGroupCode+key"
                    class="product_card"
                    :name="getProductLanguage(subGroup, 'subGroupName')"
                    :image="getImagesURL(subGroup, 'subGroupImages', 'large')"
                    :subGroup="subGroup"
                    :subGroupIndex="key"
                    @selectCurGroup="selectCurGroup">
                </SubGroupCard>
            </template>
            <template v-else>
                <ProductCard
                    v-for="(prod, key) in removeProd(subGroupProducts || category && category['products'])" :key="category.groupCode+prod.productCode+key"
                    class="product_card"
                    :name="getProductLanguage(prod, 'productName')"
                    :image="getImagesURL(prod, 'productImages', 'large')"
                    :price="prod.price"
                    :prod="prod"
                    :blockProds="blockProds"
                    @selectCurprod="selectCurprod">
                </ProductCard>
            </template>
        </transition-group>
        <ProductBarcodeScanner v-if="isScannerEnable()"/>
        <div class="overlay" v-if="showSuggestionsMenuModal"></div>
        <Transition name="bounce">
            <SuggestionsMenuModal v-if="showSuggestionsMenuModal" :productCode="suggestProductCode" :groupCode="suggestGroupCode" @handleSuggestion="handleSuggestion" @closeSuggestionsMenuModal="closeSuggestionsMenuModal" :indexCart="lastIndexNotSuggested" @navigateToGroup="navigateToGroup"></SuggestionsMenuModal>
        </Transition>
    </div>
</template>

<script>
import ProductCard from '@/components/ProductCard'
import SubGroupCard from '@/components/SubGroupCard'
import ProductController from '@/assets/controllers/ProductController'
import Util from '@/assets/libs/util'
import LocaleController from '../assets/controllers/LocaleController'
import ProductBarcodeScanner from '@/components/ProductBarcodeScanner'
import SuggestionsMenuModal from '@/components/SuggestionsComponents/SuggestionsMenuModal'
import eventModule from '@/assets/libs/eventModule'
import CartController from '@/assets/controllers/CartController'
import SuggestionsController from '@/assets/controllers/SuggestionsController'
import ClarityController from '@/assets/controllers/ClarityController'
export default {
    name: 'ProductGrid',
    props: ['category', 'routeSubGroupIndex', 'blockProds'],
    components: {
        ProductCard,
        SubGroupCard,
        ProductBarcodeScanner,
        SuggestionsMenuModal
    },
    data () {
        return {
            enableSubgroups: Util.getLocalConfigs('enableSubgroups'),
            subGroupProducts: null,
            categoryGroupCode: null,
            showSuggestionsMenuModal: false,
            suggestProductCode: null,
            suggestGroupCode: null,
            ignoreNextSuggestions: false,
            lastIndexNotSuggested: null
        }
    },
    methods: {
        isScannerEnable: function () {
            return Util.allowProdBarCodeRead()
        },
        removeProWithoutImage: function (prods) {
            let produtoSemfoto = Util.getLocalConfigs('produtoSemfoto') === true
            return (prods || []).filter(p => produtoSemfoto || (p.productImages && p.productImages.small))
        },
        removeBlockedProds: function (prods) {
            let blockProds = this.blockProds
            return (prods || []).filter(p => (blockProds.indexOf(p.productCode) === -1))
        },
        removeProd: function (prods) {
            let filtredProds = this.removeProWithoutImage(prods)
            filtredProds = this.removeBlockedProds(filtredProds)
            filtredProds = Util.removeHiddenProducts(filtredProds)
            filtredProds = Util.removeHourlyUnavailableProds(filtredProds)
            return filtredProds
        },
        checkConditionsToSubGrup: function (category) {
            let checkCategorie = category && (category.subGroups.length > 0 && category.subGroups[0].subGroupName)
            return checkCategorie && this.enableSubgroups && !this.subGroupProducts
        },
        selectCurGroup: function (subGroupData) {
            this.subGroupProducts = subGroupData && subGroupData.products
            this.subGroupIndex = subGroupData && subGroupData.subGroupIndex
            this.categoryGroupCode = (subGroupData && subGroupData.groupCode) || ''
            this.$forceUpdate()
        },
        handleSuggestion: function (prod, ignoreNextSuggestions) {
            if (ignoreNextSuggestions) {
                this.ignoreNextSuggestions = true
                this.closeSuggestionsMenuModal()
            }
            this.selectCurprod(prod)
        },
        selectCurprod: function (prod) {
            // this.closeSuggestionsMenuModal()
            let seletctedProduct = JSON.parse(JSON.stringify(prod))
            seletctedProduct.catGroupName = this.category && this.category.groupName
            seletctedProduct.categoryGroupCode = (this.category && this.category.groupCode) || ''
            seletctedProduct.subGroupIndex = this.subGroupIndex
            ClarityController.event('usuario_visualizou_produto')
            ClarityController.setTag('produto_visualizado', seletctedProduct.productName)
            if (seletctedProduct.hasComboProducts) {
                ProductController.getProductCombos(prod.productCode).then((values) => {
                    seletctedProduct.productcombosChoice = values
                    this.$router.push({
                        name: 'ProductItem',
                        params: seletctedProduct
                    })
                })
            } else {
                this.$router.push({
                    name: 'ProductItem',
                    params: seletctedProduct
                })
            }
        },
        getImagesURL: function (prod, prop, size) {
            /* let url = Util.getLocalConfigs('urlIMGOdhenInterface')
            if (url && url.length && url[url.length - 1] === '/' && url[url.length - 2 === '/']) {
                url = url.substring(0, url.length - 1)
            }
            // let uri = (prod[prop] && prod[prop].small)   // Linha alterada temporariamente ate que a interface modifique o tamanho retornado da imagem
            let uri = (prod[prop] && prod[prop].large)      // Apos alteracao na interface, retornar a linha de cima e apagar esta
            return uri && (url + uri) */
            return Util.getImagesUrl(prod, prop, size)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        openSuggestionsMenuModal: async function () {
            let cart = CartController.getCart()
            if (cart.length === 0) return

            const pendingGroup = SuggestionsController.getPendingGroupSuggestion()
            if (pendingGroup) {
                const lastItem = cart[cart.length - 1]
                const pendingResult = SuggestionsController.confirmPendingGroupSuggestion(
                    (lastItem && lastItem.categoryGroupCode) || ''
                )
                if (pendingResult === 'no_new_product') {
                    return
                }
                if (pendingResult === 'match' && lastItem) {
                    lastItem.productSuggested = true
                }
            }

            // Verifica se já existe um fluxo ativo e mantém o contexto
            const activeFlow = SuggestionsController.getActiveFlowContext()
            if (activeFlow) {
                this.lastIndexNotSuggested = activeFlow.indexCart
                this.suggestProductCode = activeFlow.productCode
                this.suggestGroupCode = activeFlow.groupCode
                this.showSuggestionsMenuModal = true
                return
            }

            this.lastIndexNotSuggested = cart.findLastIndex(item => !item.productSuggested)
            if (this.lastIndexNotSuggested === -1) return

            let cartItem = cart[this.lastIndexNotSuggested]
            let productCode = cartItem.productCode
            let groupCode = cartItem.categoryGroupCode

            if (!productCode || !groupCode) return

            this.suggestProductCode = productCode
            this.suggestGroupCode = groupCode

            if (!(await SuggestionsController.hasSuggestions(groupCode, productCode))) return
            if (SuggestionsController.checkIfIgnoreAllSuggestions()) return

            this.showSuggestionsMenuModal = true
        },
        closeSuggestionsMenuModal: function () {
            this.showSuggestionsMenuModal = false
            this.suggestProductCode = null
            this.suggestGroupCode = null
        },
        navigateToGroup: function (groupName) {
            this.closeSuggestionsMenuModal()
            eventModule.$emit('navigateToGroup', groupName)
        }
    },
    watch: {
        category: function () {
            let sf = this
            sf.selectCurGroup(null)
            if (!sf.enableSubgroups && sf.category && sf.category.subGroups.length > 0) {
                let prods = []
                sf.category.subGroups.forEach(sbg => {
                    prods = prods.concat(sbg.products)
                })
                sf.selectCurGroup({products: prods, subGroupIndex: null})
            }
            setTimeout(() => {
                if (sf.routeSubGroupIndex != null && sf.category && sf.category['subGroups'] && sf.enableSubgroups) {
                    let subGroupData = {products: sf.category['subGroups'][sf.routeSubGroupIndex].products, subGroupIndex: sf.routeSubGroupIndex}
                    sf.selectCurGroup(subGroupData)
                }
            }, 300)
        }
    },
    created () {
        eventModule.$on('openSuggestionsMenuModal', this.openSuggestionsMenuModal)
    },
    beforeDestroy () {
        eventModule.$off('openSuggestionsMenuModal', this.openSuggestionsMenuModal)
    },
    mounted () {
        this.ignoreNextSuggestions = SuggestionsController.checkIfIgnoreAllSuggestions()
        if (!this.ignoreNextSuggestions) {
            setTimeout(() => {
                this.openSuggestionsMenuModal()
            }, 1000)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

@import (reference) url("../assets/common.less");
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 4;
}
ul{
    display: grid;
    grid-template-columns: 33% 33% 33%;
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
    padding-bottom: 120px;
}
.list-enter-active {
    transition: all .8s ease-in-out;
    transition-delay: .3s;
}
.list-leave-active{
    transition: all .3s ease-in-out;
}

.list-enter {
    transform: translate(-100vw);
}
.list-leave-to {
    opacity: 0;
    transform: translate(0, -100%);
}

@media (max-width: 698px) { // Gertec SK210
    ul{
        grid-template-columns: 50% 50%;
    }
}

@media (min-width: 699px) and (max-width: 900px) {
    ul{
        // grid-template-columns: 50% 50%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/ProductGrid.vue